import HttpCotinService from './HttpCotinService';

const CONTROLLER = 'BFFProxy/configuracoesdeusuarios';

type AvatarListener = (avatarUrl: string | null) => void;

const avatarListeners = new Set<AvatarListener>();

function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const dataUrl = reader.result as string;
            const base64 = dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl;
            resolve(base64 || '');
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

function buildUploadDto(loginAD: string, base64File: string, fileName: string) {
    return {
        LoginAD: loginAD,
        Base64File: base64File,
        FileName: fileName,
        loginAD,
        base64File,
        fileName,
    };
}

export function subscribeAvatarUpdates(listener: AvatarListener): () => void {
    avatarListeners.add(listener);
    return () => avatarListeners.delete(listener);
}

export function notifyAvatarUpdate(avatarUrl: string | null): void {
    avatarListeners.forEach((listener) => listener(avatarUrl));
}

export async function getAvatarUrl(loginAD: string): Promise<string | null> {
    if (!loginAD?.trim()) {
        return null;
    }

    try {
        const avatarUrl = await HttpCotinService.Get<string>(
            `${CONTROLLER}/GetAvatar/${encodeURIComponent(loginAD.trim())}`
        );
        return avatarUrl || null;
    } catch {
        return null;
    }
}

export async function uploadAvatar(loginAD: string, file: File): Promise<string> {
    const login = loginAD?.trim();
    if (!login || !file) {
        throw new Error('Usuário ou arquivo inválido para upload de avatar.');
    }

    const base64File = await fileToBase64(file);
    const avatarUrl = await HttpCotinService.Post<string>(
        `${CONTROLLER}/UploadAvatar`,
        buildUploadDto(login, base64File, file.name)
    );

    if (!avatarUrl) {
        throw new Error('A API não retornou a foto de perfil após o upload.');
    }

    return avatarUrl;
}

export async function deleteAvatar(loginAD: string): Promise<boolean> {
    if (!loginAD?.trim()) {
        return false;
    }

    try {
        const removido = await HttpCotinService.Delete<boolean>(
            `${CONTROLLER}/DeleteAvatar/${encodeURIComponent(loginAD.trim())}`
        );
        return Boolean(removido);
    } catch (error) {
        console.error('Erro ao deletar avatar:', error);
        return false;
    }
}
